import React, { useEffect, useState } from 'react';

const CanvasImage = ({ 
  src, 
  alt, 
  className = '', 
  style = {},
  watermarkText = 'Safarnamah.com',
  quality = 0.7,
  onLoad,
  onError,
  ...props 
}) => {
  const canvasRef = React.useRef(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const img = new Image();
    img.crossOrigin = 'anonymous';
    
    img.onload = () => {
      try {
        const ctx = canvas.getContext('2d');
        
        // Set canvas dimensions
        canvas.width = img.width;
        canvas.height = img.height;
        
        // Draw the image
        ctx.drawImage(img, 0, 0);
        
        // Add subtle noise overlay for protection
        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        for (let i = 0; i < data.length; i += 4) {
          if (Math.random() < 0.02) {
            data[i] = Math.random() * 255;
            data[i + 1] = Math.random() * 255;
            data[i + 2] = Math.random() * 255;
          }
        }
        ctx.putImageData(imageData, 0, 0);
        
        if (onLoad) onLoad({ target: canvas });
      } catch (err) {
        console.error('Canvas rendering error:', err);
        setError(true);
        if (onError) onError(err);
      }
    };

    img.onerror = (err) => {
      setError(true);
      if (onError) onError(err);
    };

    img.src = src;
  }, [src, watermarkText, quality, onLoad, onError]);

  const handleContextMenu = (e) => {
    e.preventDefault();
    return false;
  };

  const handleDragStart = (e) => {
    e.preventDefault();
    return false;
  };

  const canvasStyle = {
    userSelect: 'none',
    WebkitUserSelect: 'none',
    MozUserSelect: 'none',
    msUserSelect: 'none',
    WebkitUserDrag: 'none',
    MozUserDrag: 'none',
    userDrag: 'none',
    pointerEvents: 'auto',
    maxWidth: '100%',
    height: 'auto',
    ...style
  };

  if (error) {
    return (
      <img 
        src={src} 
        alt={alt} 
        className={className}
        style={style}
        onContextMenu={handleContextMenu}
        onDragStart={handleDragStart}
        {...props}
      />
    );
  }

  return (
    <canvas
      ref={canvasRef}
      className={`canvas-image ${className}`}
      style={canvasStyle}
      onContextMenu={handleContextMenu}
      onDragStart={handleDragStart}
      alt={alt}
      {...props}
    />
  );
};

export default CanvasImage;